// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pad_gfco4 {
  padding: var(--size-padLarge, 10px);
}

.header_BXi0i {
  position: relative;
}

.close_zMhlX {
  position: absolute;
  z-index: 1;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}

.locatorError_TetoZ {
  margin: 0 auto;
}

.detailPair_eGXT1 {
  padding: 10px 0;
}

.detailPair_eGXT1 {
  border-bottom: 1px solid var(--color-base100);
}
.detailPair_eGXT1:last-child {
  border-bottom: none;
}

.unpairOption_IZjD0 {
  border : 1px solid var( --color-base200 );
  background-color: var( --color-white );
  padding : var( --size-padMedium );
  border-radius : var( --size-padSmall );
}

.unpairOption_IZjD0 > .unpairOption_IZjD0 {
  border : unset;
  background-color: unset;
  padding: unset;
  border-radius: unset;
}

.activeUnpairOption_AV4iJ {
  border : 1px solid var( --color-brand200 );
  background-color: var( --color-brand025 );
  padding : var( --size-padMedium );
  border-radius : var( --size-padSmall );
}

.activeUnpairOption_AV4iJ > .activeUnpairOption_AV4iJ {
  border : unset;
  background-color: unset;
  padding: unset;
  border-radius: unset;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/views/pairing/PairForm.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6CAA6C;AAC/C;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,sCAAsC;EACtC,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,yCAAyC;EACzC,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,cAAc;EACd,oBAAoB;AACtB","sourcesContent":[".pad {\n  padding: var(--size-padLarge, 10px);\n}\n\n.header {\n  position: relative;\n}\n\n.close {\n  position: absolute;\n  z-index: 1;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n}\n\n.locatorError {\n  margin: 0 auto;\n}\n\n.detailPair {\n  padding: 10px 0;\n}\n\n.detailPair {\n  border-bottom: 1px solid var(--color-base100);\n}\n.detailPair:last-child {\n  border-bottom: none;\n}\n\n.unpairOption {\n  border : 1px solid var( --color-base200 );\n  background-color: var( --color-white );\n  padding : var( --size-padMedium );\n  border-radius : var( --size-padSmall );\n}\n\n.unpairOption > .unpairOption {\n  border : unset;\n  background-color: unset;\n  padding: unset;\n  border-radius: unset;\n}\n\n.activeUnpairOption {\n  border : 1px solid var( --color-brand200 );\n  background-color: var( --color-brand025 );\n  padding : var( --size-padMedium );\n  border-radius : var( --size-padSmall );\n}\n\n.activeUnpairOption > .activeUnpairOption {\n  border : unset;\n  background-color: unset;\n  padding: unset;\n  border-radius: unset;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pad": `pad_gfco4`,
	"header": `header_BXi0i`,
	"close": `close_zMhlX`,
	"locatorError": `locatorError_TetoZ`,
	"detailPair": `detailPair_eGXT1`,
	"unpairOption": `unpairOption_IZjD0`,
	"activeUnpairOption": `activeUnpairOption_AV4iJ`
};
export default ___CSS_LOADER_EXPORT___;
